<div class="material-header">
  <div>
    <img src="../assets/images/logo.png" class="logo" alt="Logo" />
  </div>
  <div class="material-button-container">
    <button mat-icon-button aria-label="Search">
      <mat-icon>search</mat-icon>
    </button>

    <button mat-icon-button aria-label="Help">
      <mat-icon>question_mark</mat-icon>
    </button>

    <button mat-icon-button aria-label="Notifications">
      <mat-icon>notifications_none</mat-icon>
    </button>

    <img src="../assets/images/puppy.png" class="logo logo-button" alt="Puppy" />
  </div>
</div>
